import { filter } from 'lodash';

/* eslint-disable no-unused-vars */
export enum ErrorRouteKeys {
  Root = '/error',
}

export enum AuthRouteKeys {
  Home = '/',
  Onboarding = '/onboarding',
  Bookmark = '/bookmark',
  AccountProfile = '/account/profile',
  NewsFeed = '/community/news_feed',
  MyCompany = '/community/my_company',
  MyGroups = '/community/my_groups',
  MyContacts = '/community/moy_contacts',
  CompanyProfiles = '/company/profiles',
  CompanyDetail = '/company/profile/:id?',
  CompanyPrintPage = '/company/profile/:id/print',
  PeopleProfiles = '/people/profiles',
  PeopleDetail = '/people/profile/:id?',
  CompareCompany = '/compare_company',
  TariffsAndRules = '/tariff_and_rule',
  Setting = '/setting',
  TradeData = '/trade_data',
  BillOfLadingDetail = '/bill_of_lading/:id?',
  Pricing = '/pricing',
  Checkout = '/order/checkout',
  BankTransfer = '/order/bank-transfer',
  OrderConfirmation = '/order/confirmation',
  TradeDataProductList = '/trade_data/products',
  AIHSCodeSearch = '/ai_hs_code_labeling',
  AIHSCodeSearchResult = '/ai_hs_code_labeling/single_search_result',
  AIHSCodeBulkResult = '/ai_hs_code_labeling/bulk_upload_search_result/:id',
  PortDetail = '/port/detail/:id?',
  Port = '/port',
  CalendarBooking = '/adamftd-demo-booking',
  Activities = '/activities',
  Vessels = '/vessels',
  VesselDetail = '/vessels/:id',
  Contribution = '/contributions',
  ContributionDetail = '/contribution/:contributionType/:id?',
  Sanctions = '/sanctions',
  SanctionDetail = '/sanctions/:id',
  AiReport = '/ai_report',
  CompanyTradeData = '/company_trade_data',
  AnalyticsPackage = '/analytics_package',
}

export enum NoAuthRouteKeys {
  Login = '/login',
  SignUp = '/signup',
  ForgotPassword = '/forgot_password',
  TwoStepVerification = '/two_step_verification',
  ResetPassword = '/reset_password',
  TermAndCondition = '/term_conditions',
  GeneralDisclaimer = '/general_disclaimer',
  TradeDataLimitations = '/trade_data_limitations',
  CampaignLandingPage = '/campaign_program/:campaign_slug',
  TariffsAndRulesPublic = '/public/tariffs_and_rules',
  AIHSCodeSearchPublic = '/public/ai_hs_code_labeling',
  AIHSCodeSearchResultPublic = '/public/ai_hs_code_labeling/single_search_result',
  TradeData = '/public/trade_data',
}

export const ROUTES_BY_PLAN_CATEGORY_TYPE = [
  {
    categoryId: 1,
    categoryTypeName: 'INTERNAL_TRADE_DATA',
    route: AuthRouteKeys.TradeData,
    isDefault: true,
  },
  {
    categoryId: 2,
    categoryTypeName: 'INTERNAL_COMPANY_DUE_DILIGENCE',
    route: AuthRouteKeys.CompanyProfiles,
    isDefault: false,
  },
  {
    categoryId: 3,
    categoryTypeName: 'INTERNAL_PEOPLE_SEARCH',
    route: AuthRouteKeys.PeopleProfiles,
    isDefault: false,
  },
  {
    categoryId: 4,
    categoryTypeName: 'INTERNAL_TARIFFS_AND_RULES',
    route: AuthRouteKeys.TariffsAndRules,
    isDefault: true,
  },
  {
    categoryId: 5,
    categoryTypeName: 'INTERNAL_COMPARE_COMPANY',
    route: AuthRouteKeys.CompareCompany,
    isDefault: false,
  },
  {
    categoryId: 9,
    categoryTypeName: 'INTERNAL_AI_HS_CODE_LABELING',
    route: AuthRouteKeys.AIHSCodeSearch,
    isDefault: true,
  },
  {
    categoryId: 10,
    categoryTypeName: 'INTERNAL_PORTS_INFORMATION',
    route: AuthRouteKeys.Port,
    isDefault: false,
  },
  {
    categoryId: 11,
    categoryTypeName: 'INTERNAL_VESSEL_INFORMATION',
    route: AuthRouteKeys.Vessels,
    isDefault: false,
  },
  {
    categoryId: 12,
    categoryTypeName: 'INTERNAL_REPORT',
    route: AuthRouteKeys.AiReport,
    isDefault: false,
  },
  {
    categoryId: 14,
    categoryTypeName: 'INTERNAL_ANALYTICS_PACKAGE',
    route: AuthRouteKeys.AnalyticsPackage,
    isDefault: false,
  },
];
export const ROUTES_BY_PLAN_CATEGORY_TYPE_DEFAULT = filter(ROUTES_BY_PLAN_CATEGORY_TYPE, ({ isDefault }) => isDefault);
